import { LocationObject } from '@pflegia/types/common/location/location-object';

import { bigCityAreas, CityArea } from './big-city-areas';

const COUNTRY = 'Deutschland';
const BIG_CITY_NAMES = new Set(Object.keys(bigCityAreas));

export const isBigCityLocation = (location?: Partial<LocationObject> | null): boolean => {
  const city = location?.city?.trim();
  if (!city || !BIG_CITY_NAMES.has(city)) return false;
  if (location?.postalCode || location?.streetAddressAndNumber) return false;
  return location?.formattedAddress?.trim() === `${city}, ${COUNTRY}`;
};

export const getFirstBigCityLocation = (locations?: LocationObject[] | null): LocationObject | undefined =>
  locations?.find(location => isBigCityLocation(location));

export const toAreaLocation = (area: CityArea, cityLocation: LocationObject): LocationObject => ({
  administrativeAreaLevel1: cityLocation.administrativeAreaLevel1,
  city: cityLocation.city,
  country: COUNTRY,
  countryCode: cityLocation.countryCode,
  formattedAddress: `${area.name}, ${cityLocation.city}, ${COUNTRY}`,
  lat: area.lat,
  lng: area.lng,
  placeId: '',
  postalCode: null,
  state: cityLocation.state,
});

export const mergeCityAreas = (locations: LocationObject[], areas?: LocationObject[] | null): LocationObject[] => {
  if (!areas?.length) return locations;
  const bigCity = getFirstBigCityLocation(locations);
  if (!bigCity) return locations;
  return locations.flatMap(location => (location === bigCity ? areas : [location]));
};
